<template>
  <div class="text-center">
    <router-link to="/" class="logo">
      <i class="logo-icon">
        <img src="../../assets/images/logo-mini-white.png" height="30" />
      </i>
      <span>
        <img src="../../assets/images/logo-white.png" height="30" />
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Logo"
};
</script>

<style lang="scss">
.logo {
  color: #ffffff !important;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.05em;
  line-height: 68px;
  text-transform: uppercase;

  & &-icon {
    display: none;
  }
  #wrapper.enlarged .topbar .topbar-left & {
    .logo-icon {
      display: block;
      line-height: 60px;
    }
    span {
      display: none;
      opacity: 0;
    }
  }
}
</style>
